export default __webpack_public_path__ + "static/media/streamer_studio.4b5c034e.svg";